import { render, staticRenderFns } from "./OffersDeactivate.vue?vue&type=template&id=70bdd578&scoped=true"
import script from "./OffersDeactivate.vue?vue&type=script&lang=js"
export * from "./OffersDeactivate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70bdd578",
  null
  
)

export default component.exports